'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _UserAvatar = require('./UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _UserAvatar2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/UserAvatar/index.js
// module id = 695
// module chunks = 11